<template lang="pug">
    canvas
</template>

<script type="text/babel">
  import Chart from 'chart.js'
  import Vue from 'vue'

  export default Vue.extend({
    name: "BaseChart",

    props: [
      'data'
    ],
    watch: {
      data: function (newVal) {
        this.chart.data = this.buildDataset()
        this.chart.update()
      }
    },
    mounted() {
      var context = this.$el.getContext("2d");

      if (typeof this.customBuilder == 'function') {
        this.chart = this.customBuilder(context)
      } else {
        this.chart = new Chart(context, this.config);
      }
    },
    methods: {
      getColor: function (index) {
        var baseColors = {
          red: 'rgb(255, 99, 132)',
          orange: 'rgb(255, 159, 64)',
          yellow: 'rgb(255, 205, 86)',
          green: 'rgb(75, 192, 192)',
          blue: 'rgb(54, 162, 235)',
          purple: 'rgb(153, 102, 255)',
          grey: 'rgb(201, 203, 207)'
        }

        var color = baseColors[Object.keys(baseColors)[index]]

        // Generate a color if we don't have one
        if (!color) {
          color = 'rgb(' + Math.floor((Math.random() * 255) + 0) + ',' + Math.floor((Math.random() * 255) + 0) + ',' + Math.floor((Math.random() * 255) + 0) + ')'
        }

        return color
      }
    },
    data() {
      return {
        chart: null,
        config: {
          type: this.getChartType(),
          data: this.buildDataset(),
          options: {
            title: {
              text: "Chart.js"
            },
          }
        }
      }
    }
  })
</script>

<style lang="sass">
    canvas
        -moz-user-select: none
        -webkit-user-select: none
        -ms-user-select: none
</style>



// WEBPACK FOOTER //
// BaseChart.vue?8dd3c214